import React from "react";
import "../../css/Main_act_loan.css";
import image from "../../images/banner_img.png";
import google_play from "../../images/google_play_btn.png";
import app_store from "../../images/app_store_btn.png";
import Typewriter from "typewriter-effect";
export const Banner = () => {
  return (
    <div className="banner maxw-1350">
      <div className="banner-left my-center">
        <div className="banner-title">
Financial Help is just a Click Away!

      <span className="title-theme-color"> Need Funds Right Away?
</span>
          <span className="title-theme-color">
            <Typewriter
              options={{
                strings: [
                  "Apply from Anywhere",
                  "Paperless Process",
                  "Instant Approval",
                  "Quick money",
                
                ],
                autoStart: true,
                loop: true,
              }}
            />{" "}
          </span>
        </div>
        {/* <div className="banner-des">
          At Credu Moneys, we think everyone should access to financial
          help.Whether you need money for a new project, to handle surprise
          expenses, or to reach your goal, we're here to support you all the
          way.
        </div> */}
        <div className="banner-button">
          <a href="https://play.google.com/store/apps/details?id=com.credumoney.credumoney&pcampaignid=web_share" target="_blank" className="button-1 mx-center my-1">
            <img src={google_play} alt="Credu Money app" />
          </a>
          <div className="button-2 mx-center my-1">
            <img src={app_store} alt="Credu Money app" />
          </div>
        </div>
      </div>

      <div className="banner-right mx-center mt-3">
        <img className="ml-auto" src={image} alt="Credu Money banner" />
      </div>
    </div>
  );
};
